export const ClassificationMap = {
  T: 'T – Taxable',
  E: 'E – Excludable',
  V: 'V – Vendor Excludable',
  O: 'O – Other Service non-Tax Assistance',
  P: 'P - Property',
  F: 'F - FICA Only',
  MT: 'MT – Memo Taxable – On 4782, No GUP',
  N: 'N – Other Taxable, No GrossUp',
  MN: 'MN – Memo NonTaxable'
};

export const CategoryMap = {
  EA: { id: 'B71F7E27-8179-4588-BBD6-A53828940678', title: 'EA - Equity Acquired' },
  OE: { id: '931CB620-AAD1-4339-90D9-D9E50C21A3C0', title: 'OE - Other Expenses' },
  PC: { id: '74156C34-07F8-4108-9931-4F3C2312FAEE', title: 'PC - Property Costs' },
  PM: { id: '3D663629-4D8B-427A-AFC6-4FBF799B1EB4', title: 'PM - Property Management' },
  FR: { id: '3EE182CC-F276-44C4-9503-ACBBE86E8B88', title: 'FR - Funds Received' },
  F: { id: '1819E3FA-56D0-4670-9440-58E99778F2AE', title: 'F - Fees' },
  AC: { id: '80E3EA2D-F01F-4E45-8865-48A9478D66B8', title: 'AC - Acquisition' },
  RC: { id: '7BD9D7F1-5B41-4C89-A62D-83E2A489251C', title: 'RC - Recurring Carrying Costs' },
  NC: { id: '4FF2187D-1F7C-48C6-AF15-7F01A21F5FF7', title: 'NC - Non-Recurring Costs' },
  DC: { id: '7666B14C-9A37-480C-BCC1-20DA9978EA43', title: 'DC - Disposition' },
  AD: { id: 'DCC32C25-038E-4E9D-8CB9-CCD69D93FCA2', title: 'AD - Administrative' },
  IT: { id: '31DEF875-7861-4692-9AB5-72715842EB50', title: 'IT - Interest' },
  HHG: { id: '963482D3-78DA-4B1C-978A-16220C82613D', title: 'HHG - House Hold Goods' },
  TRIP: { id: 'AA8286DE-0460-4C3B-8A00-97EEEC4F1A1C', title: 'TRIP - Trip En Route' },
  HH: { id: '49CFF58D-2B21-4720-A91C-31D45C242750', title: 'HH - House Hunting' },
  TL: { id: '22A6D90E-3CC8-4EF9-AF02-4C32FCC13400', title: 'TL - Temporary Living' },
  OLDR: { id: 'F5BCBE9A-438C-4BD8-8783-BC61BAAB7FC4', title: 'OLDR - Old Residence' },
  NEWR: { id: '844B90AB-C358-43E2-AC12-30D71AB355DC', title: 'NEWR - New Residence' },
  OTH: { id: '02171C4A-5CFC-424A-B21B-A58C119187E6', title: 'OTH - Other Expenses' },
  TP: { id: 'B8C5F219-ECFB-49D8-84F1-31A35236CA11', title: 'TP - Third Party' }
};

export const getExpenseCategory = category => CategoryMap[category] || null;

export const getExpenseCategoryId = category => getExpenseCategory(category)?.id || null;

export const getExpenseCategoryTitle = category => getExpenseCategory(category)?.title || category;

export const transformExpenses = expenses => {
  if (!expenses || !Array.isArray(expenses)) return [];

  return expenses.map(expense => {
    const classificationFullName = ClassificationMap[expense.classification] || expense.classification;
    const categoryFullName = getExpenseCategoryTitle(expense.category);

    return {
      ...expense,
      classificationFullName,
      categoryFullName
    };
  });
};

export const CreateExpenseCodeSearchInfo = (expenseCodes, clientPreferredExpenseCodes, clientId) => {
  let searchingRows = transformExpenses(expenseCodes);

  const preferredExpenseCodesForClient =
    clientPreferredExpenseCodes && Array.isArray(clientPreferredExpenseCodes)
      ? clientPreferredExpenseCodes.filter(code => code.clientId === clientId)
      : [];
  const addClientPreferredColumn = preferredExpenseCodesForClient.length > 0;

  const searchingColumns = [
    { name: 'expenseCodeCode', title: 'Expense Code', autoFocus: true },
    { name: 'expenseCodeDescription', title: 'Description' },
    { name: 'classificationFullName', title: 'Classification', type: 'dropdown', options: Object.values(ClassificationMap) },
    { name: 'categoryFullName', title: 'Category', type: 'dropdown', options: Object.values(CategoryMap).map(category => category.title) }
  ];

  const searchingColumnExtensions = [
    { columnName: 'expenseCodeCode', width: 150 },
    { columnName: 'expenseCodeDescription', width: 250 },
    { columnName: 'classificationFullName', width: 200 },
    { columnName: 'categoryFullName', width: 200 }
  ];

  if (addClientPreferredColumn) {
    searchingColumns.push({
      name: 'clientPreferred',
      title: 'Client Preferred',
      type: 'dropdown',
      options: Object.values(CategoryMap).map(category => category.title)
    });

    searchingColumnExtensions.push({
      columnName: 'clientPreferred',
      width: 200
    });

    searchingRows = searchingRows && Array.isArray(searchingRows) ? searchingRows : [];
    searchingRows = searchingRows.map(row => {
      const matchingPreferredCode = preferredExpenseCodesForClient.find(code => code.expenseCodeId === row.expenseCodeId);
      const clientPreferred = matchingPreferredCode ? getExpenseCategoryTitle(matchingPreferredCode.category) : '';
      return {
        ...row,
        clientPreferred
      };
    });
  }

  return {
    searchingColumns,
    searchingColumnExtensions,
    searchingRows: searchingRows,
    idKey: 'expenseCodeId',
    nameKey: 'expenseCodeCode'
  };
};

export const codeFromId = (expenseCodes, id) => {
  const ec = ecById(expenseCodes, id);
  if (!ec) return '';
  const code = ec.expenseCodeCode || ec.expenseCode || '';
  return code;
};

export const ecById = (expenseCodes, id) => expenseCodes.find(e => Number(e.expenseCodeId) === Number(id));

export const categoryLabel = (expenseCodes, id) => {
  const ec = ecById(expenseCodes, id);
  return ec && ec.category ? ec.category : '—';
};

export const descriptionFromId = (expenseCodes, id) => {
  const ec = ecById(expenseCodes, id);
  if (!ec) return '';
  const desc = ec.expenseCodeDescription || ec.description || '';
  return desc || '';
};